<template>
  <div id="app">
    <div class="auth-wrapper">
      <div class="auth-inner" >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>



import {mapState} from 'vuex';

import(/* webpackChunkName: "moment" */'moment/moment');

import(/* webpackChunkName: "Theme" */ './assets/js/theme.js');
import(/* webpackChunkName: "jquery" */'jquery/dist/jquery.min');
import(/* webpackChunkName: "daterangeicker" */'daterangepicker');
import(/* webpackChunkName: "BootStrapBundle" */'bootstrap/dist/js/bootstrap.bundle.min');
import 'material-icons/iconfont/material-icons.css';
import {applySeasonFavicon, applySeasonTitle} from '@/Helpers/global/season';
import darkCssUrl from '!!file-loader?name=css/[name].[contenthash:8].[ext]!@/assets/css/dark.css'
export default {
    name: 'App',
    data() {
        return {
            DARK_ID: 'theme-dark-css',
            darkCssUrl
        }
    },
    computed:{
        ...mapState({darkTheme:'darkTheme'})
    },
    watch:{
        darkTheme(val){
            if (val === 'ativo'){
                this.enableDark();
            }else{
                this.disableDark();
            }
        }
    },
    mounted() {
        if (this.darkTheme === 'ativo'){
            this.enableDark();
        }else {
            this.disableDark();
        }
        // Festas: favicon com gorro, saudação no título da aba e o relógio da decoração (a cada 30 s e na volta
        // para a aba, já que o timer atrasa em aba oculta)
        applySeasonFavicon(this.$store.state.seasonNow);
        applySeasonTitle(this.$store.state.seasonNow);
        this.seasonClock = setInterval(this.tickSeasonClock, 30000);
        document.addEventListener('visibilitychange', this.onSeasonVisibility);
    },
    beforeUnmount() {
        clearInterval(this.seasonClock);
        document.removeEventListener('visibilitychange', this.onSeasonVisibility);
    },
    methods: {
        tickSeasonClock() {
            this.$store.dispatch('ActionTickSeasonClock');
        },
        onSeasonVisibility() {
            if (!document.hidden) this.tickSeasonClock();
        },
        enableDark() {
            if (!document.getElementById(this.DARK_ID)) {
                const link = document.createElement('link')
                link.id = this.DARK_ID
                link.rel = 'stylesheet'
                link.href = this.darkCssUrl
                document.head.appendChild(link)
            }
            document.documentElement.classList.add('dark-theme');
            localStorage.setItem('darkTheme', 'ativo');
        },
        disableDark() {
            document.getElementById(this.DARK_ID)?.remove()
            document.documentElement.classList.remove('dark-theme');
            localStorage.removeItem('darkTheme')
        },
    }
}
</script>

<style lang="css" scoped>
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "assets/fonts/style.css";
@import "assets/css/main.css";
@import '~@fortawesome/fontawesome-free/css/all.css';
@import "assets/css/prism/prism.css";
</style>

<style lang="scss">

.required:after {
  content:" *";
  color: red;
}
::-webkit-scrollbar {
    width: 6px;       /* vertical */
    height: 6px;      /* horizontal */
}

/* Parte móvel da barra */
::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}

.scroll-area {
    scrollbar-width: thin;
    scrollbar-color: #888 transparent;
}
</style>
